import { getLocalizedValue } from "@repo/shared";
import type { LocalizedString } from "@repo/shared/types";
import { useCallback } from "react";
import { useUserLanguage } from "./context";

/** Reads tenant-edited text: what `useLocalize()` returns. */
export type Localize = (value: string | LocalizedString | null | undefined) => string;

/**
 * QL-17 — read tenant-edited text (`nameI18n` etc.) in the current language:
 * the user's own, or the flow's inside `FlowLanguageScope`. Missing
 * translations fall back to the tenant's default language, then en_GB, then
 * any language. A plain string comes back as it is.
 * Non-React code takes a `Localize` parameter, or calls `getLocalizedValue`
 * from `@repo/shared` with the tenant default as the fallback.
 */
export function useLocalize(): Localize {
  const { userLanguage, tenantDefaultLanguage } = useUserLanguage();
  return useCallback(
    (value) => getLocalizedValue(value, userLanguage, tenantDefaultLanguage),
    [userLanguage, tenantDefaultLanguage],
  );
}
